import React, { useState, useEffect } from 'react';

const API = 'https://api.pixventa.com';

const S = {
  topbar:    { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:        { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  grid2:     { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 },
  card:      { background:'white', borderRadius:12, border:'1px solid #E4EDE8', marginBottom:16 },
  cardHdr:   { padding:'12px 16px', borderBottom:'1px solid #E4EDE8', display:'flex', justifyContent:'space-between', alignItems:'center' },
  cardTitle: { fontSize:13, fontWeight:700, color:'#0D1F1A' },
  cardBody:  { padding:16 },
  field:     { marginBottom:14 },
  label:     { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:5 },
  input:     { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'10px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  btnSave:   { padding:'9px 20px', borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  btnRojo:   { padding:'9px 20px', borderRadius:10, border:'none', background:'#c62828', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  btnGray:   { padding:'9px 20px', borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#7A8F89', fontSize:13, cursor:'pointer', fontFamily:'inherit', marginRight:8 },
  success:   { background:'#E1F5EE', border:'1px solid #5DCAA5', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#085041', marginBottom:14 },
  danger:    { background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#A32D2D', marginBottom:14 },
  divider:   { height:1, background:'#E4EDE8', margin:'14px 0' },
  toggleRow: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', borderBottom:'1px solid #E4EDE8' },
  toggleLbl: { fontSize:13, color:'#0D1F1A' },
  toggleSub: { fontSize:11, color:'#7A8F89', marginTop:2 },
  toggle:    { width:40, height:22, borderRadius:11, cursor:'pointer', border:'none', position:'relative', transition:'background .2s', flexShrink:0 },
  qrWrap:    { textAlign:'center', margin:'16px 0' },
  qrImg:     { border:'4px solid #E4EDE8', borderRadius:12, maxWidth:180 },
  badge2fa:  { display:'inline-flex', alignItems:'center', gap:6, padding:'4px 12px', borderRadius:20, fontSize:12, fontWeight:600 },
  otpWrap:   { display:'flex', gap:8, justifyContent:'center', margin:'12px 0' },
  otpInput:  { width:40, height:48, textAlign:'center', fontSize:20, fontWeight:700, background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, outline:'none', fontFamily:'inherit', color:'#0D1F1A' },
};

export default function Configuracion() {
  const [negocio,        setNegocio]        = useState({ nombre:'PixVenta', email:'admin@pixventa.com', tel:'+52 33 0000 0000', dominio:'app.pixventa.com' });
  const [msgNegocio,     setMsgNegocio]     = useState('');
  const [usuarioActual,  setUsuarioActual]  = useState({ id:null, nombre:'', email:'', rol:'' });
  const [creds,          setCreds]          = useState({ nuevoUsuario:'', passActual:'', passNueva:'', passConfirm:'' });
  const [msgCreds,       setMsgCreds]       = useState('');
  const [errorCreds,     setErrorCreds]     = useState('');
  const [guardando,      setGuardando]      = useState(false);

  // 2FA
  const [status2fa,      setStatus2fa]      = useState(false);
  const [qrCode,         setQrCode]         = useState('');
  const [secretB32,      setSecretB32]      = useState('');
  const [otp,            setOtp]            = useState(['','','','','','']);
  const [msg2fa,         setMsg2fa]         = useState('');
  const [error2fa,       setError2fa]       = useState('');
  const [paso2fa,        setPaso2fa]        = useState('idle'); // idle | qr | verificar

  // Notificaciones
  const [notif, setNotif] = useState({
    pagoVencido: true, proximoVencer: true, nuevaRegistro: true, waPagoVencido: true,
  });

  useEffect(() => {
    try {
      const u = JSON.parse(localStorage.getItem('wm_admin_user') || '{}');
      if (u.id) {
        setUsuarioActual(u);
        checkStatus2fa(u.id);
      }
    } catch(e) {}
  }, []);

  async function checkStatus2fa(id) {
    try {
      const res  = await fetch(`${API}/admin/2fa/status/${id}`);
      const data = await res.json();
      setStatus2fa(data.activo);
    } catch(e) {}
  }

  function guardarNegocio() {
    if (!negocio.nombre.trim()) return;
    setMsgNegocio('✅ Datos guardados correctamente');
    setTimeout(() => setMsgNegocio(''), 3000);
  }

  async function guardarCreds() {
    setMsgCreds(''); setErrorCreds('');
    if (!creds.passActual) { setErrorCreds('Escribe tu contraseña actual'); return; }
    if (creds.passNueva && creds.passNueva !== creds.passConfirm) { setErrorCreds('Las contraseñas nuevas no coinciden'); return; }
    if (creds.passNueva && creds.passNueva.length < 8) { setErrorCreds('La contraseña debe tener al menos 8 caracteres'); return; }
    if (!usuarioActual.id) { setErrorCreds('No se pudo identificar el usuario'); return; }
    setGuardando(true);
    try {
      const verify = await fetch(`${API}/admin/login`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ usuario: usuarioActual.email, password: creds.passActual }),
      });
      const vData = await verify.json();
      if (!vData.ok) { setErrorCreds('Contraseña actual incorrecta'); return; }

      const payload = {
        nombre:   creds.nuevoUsuario.trim() || usuarioActual.nombre,
        email:    usuarioActual.email,
        rol:      usuarioActual.rol,
        permisos: usuarioActual.permisos || {},
        estado:   'activo',
      };
      if (creds.passNueva) payload.password = creds.passNueva;

      const res  = await fetch(`${API}/admin/usuarios/${usuarioActual.id}`, {
        method:'PUT', headers:{'Content-Type':'application/json'},
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.error) { setErrorCreds(data.error); return; }

      if (creds.nuevoUsuario.trim()) {
        const updated = { ...usuarioActual, nombre: creds.nuevoUsuario.trim() };
        localStorage.setItem('wm_admin_user', JSON.stringify(updated));
        setUsuarioActual(updated);
      }
      setMsgCreds('✅ Credenciales actualizadas correctamente');
      setCreds({ nuevoUsuario:'', passActual:'', passNueva:'', passConfirm:'' });
      setTimeout(() => setMsgCreds(''), 3000);
    } catch (err) {
      setErrorCreds('Error de conexión: ' + err.message);
    } finally {
      setGuardando(false);
    }
  }

  // ── 2FA ──
  async function activar2fa() {
    setError2fa(''); setMsg2fa('');
    try {
      const res  = await fetch(`${API}/admin/2fa/setup/${usuarioActual.id}`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ email: usuarioActual.email }),
      });
      const data = await res.json();
      setQrCode(data.qr);
      setSecretB32(data.secret);
      setPaso2fa('qr');
    } catch(err) {
      setError2fa('Error generando QR: ' + err.message);
    }
  }

  function handleOtp(index, value) {
    if (!/^\d*$/.test(value)) return;
    const nuevo = [...otp];
    nuevo[index] = value.slice(-1);
    setOtp(nuevo);
    setError2fa('');
    if (value && index < 5) document.getElementById(`cfg-otp-${index+1}`)?.focus();
  }

  function handleOtpKey(index, e) {
    if (e.key === 'Backspace' && !otp[index] && index > 0) document.getElementById(`cfg-otp-${index-1}`)?.focus();
    if (e.key === 'Enter') verificar2fa();
  }

  async function verificar2fa() {
    const token = otp.join('');
    if (token.length !== 6) { setError2fa('Ingresa el código de 6 dígitos'); return; }
    try {
      const res  = await fetch(`${API}/admin/2fa/verify/${usuarioActual.id}`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token }),
      });
      const data = await res.json();
      if (!data.ok) { setError2fa('Código incorrecto. Intenta de nuevo.'); setOtp(['','','','','','']); return; }
      setStatus2fa(true);
      setPaso2fa('idle');
      setOtp(['','','','','','']);
      setMsg2fa('✅ 2FA activado correctamente. Tu cuenta está protegida.');
      setTimeout(() => setMsg2fa(''), 4000);
    } catch(err) {
      setError2fa('Error verificando código: ' + err.message);
    }
  }

  function toggleNotif(key) {
    setNotif(prev => ({ ...prev, [key]: !prev[key] }));
  }

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Configuración</h1>
      </div>

      <div style={S.grid2}>
        {/* Datos del negocio */}
        <div style={S.card}>
          <div style={S.cardHdr}><div style={S.cardTitle}>🏢 Datos del SaaS</div></div>
          <div style={S.cardBody}>
            {msgNegocio && <div style={S.success}>{msgNegocio}</div>}
            <div style={S.field}>
              <label style={S.label}>Nombre del sistema</label>
              <input style={S.input} value={negocio.nombre} onChange={e => setNegocio({...negocio, nombre:e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Email de contacto</label>
              <input style={S.input} value={negocio.email} onChange={e => setNegocio({...negocio, email:e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Teléfono de soporte</label>
              <input style={S.input} value={negocio.tel} onChange={e => setNegocio({...negocio, tel:e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Dominio principal</label>
              <input style={{ ...S.input, color:'#7A8F89', background:'#F8F8F8' }} value={negocio.dominio} disabled />
              <div style={{ fontSize:11, color:'#7A8F89', marginTop:4 }}>🔒 El dominio no se puede cambiar desde aquí</div>
            </div>
            <button style={S.btnSave} onClick={guardarNegocio}>✓ Guardar datos</button>
          </div>
        </div>

        {/* Credenciales */}
        <div style={S.card}>
          <div style={S.cardHdr}><div style={S.cardTitle}>🔐 Credenciales de acceso</div></div>
          <div style={S.cardBody}>
            {msgCreds   && <div style={S.success}>{msgCreds}</div>}
            {errorCreds && <div style={S.danger}>⚠️ {errorCreds}</div>}
            <div style={S.field}>
              <label style={S.label}>Usuario actual</label>
              <input style={{ ...S.input, color:'#7A8F89', background:'#F8F8F8' }} value={usuarioActual.nombre || '—'} disabled />
            </div>
            <div style={S.field}>
              <label style={S.label}>Email actual</label>
              <input style={{ ...S.input, color:'#7A8F89', background:'#F8F8F8' }} value={usuarioActual.email || '—'} disabled />
            </div>
            <div style={S.field}>
              <label style={S.label}>Nuevo nombre de usuario (opcional)</label>
              <input style={S.input} placeholder="Dejar vacío para no cambiar" value={creds.nuevoUsuario} onChange={e => setCreds({...creds, nuevoUsuario:e.target.value})} />
            </div>
            <div style={S.divider} />
            <div style={S.field}>
              <label style={S.label}>Contraseña actual</label>
              <input style={S.input} type="password" placeholder="••••••••" value={creds.passActual} onChange={e => setCreds({...creds, passActual:e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Nueva contraseña (opcional)</label>
              <input style={S.input} type="password" placeholder="Mínimo 8 caracteres" value={creds.passNueva} onChange={e => setCreds({...creds, passNueva:e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Confirmar nueva contraseña</label>
              <input style={S.input} type="password" placeholder="Repite la nueva contraseña" value={creds.passConfirm} onChange={e => setCreds({...creds, passConfirm:e.target.value})} />
            </div>
            <button style={{ ...S.btnSave, opacity:guardando?0.7:1 }} onClick={guardarCreds} disabled={guardando}>
              {guardando ? 'Actualizando...' : '✓ Actualizar credenciales'}
            </button>
          </div>
        </div>
      </div>

      {/* 2FA */}
      <div style={S.card}>
        <div style={S.cardHdr}>
          <div style={S.cardTitle}>📱 Verificación en dos pasos (2FA)</div>
          <span style={{ ...S.badge2fa, background: status2fa?'#E1F5EE':'#FCEBEB', color: status2fa?'#085041':'#A32D2D' }}>
            {status2fa ? '✓ Activo' : '✕ Inactivo'}
          </span>
        </div>
        <div style={S.cardBody}>
          {msg2fa   && <div style={S.success}>{msg2fa}</div>}
          {error2fa && <div style={S.danger}>⚠️ {error2fa}</div>}

          {!status2fa && paso2fa === 'idle' && (
            <>
              <p style={{ fontSize:13, color:'#7A8F89', marginBottom:16, lineHeight:1.6 }}>
                Activa la verificación en dos pasos para proteger tu cuenta con Google Authenticator. Cada vez que inicies sesión necesitarás ingresar un código de 6 dígitos adicional.
              </p>
              <button style={S.btnSave} onClick={activar2fa}>📱 Activar 2FA con Google Authenticator</button>
            </>
          )}

          {paso2fa === 'qr' && (
            <>
              <p style={{ fontSize:13, color:'#7A8F89', marginBottom:12, lineHeight:1.6 }}>
                <strong>Paso 1:</strong> Abre Google Authenticator en tu teléfono y escanea este código QR.
              </p>
              <div style={S.qrWrap}>
                <img src={qrCode} alt="QR Code 2FA" style={S.qrImg} />
              </div>
              <div style={{ background:'#F0F4F0', borderRadius:8, padding:'8px 12px', fontSize:11, color:'#7A8F89', marginBottom:16, wordBreak:'break-all' }}>
                <strong>Clave manual:</strong> {secretB32}
              </div>
              <p style={{ fontSize:13, color:'#7A8F89', marginBottom:12 }}>
                <strong>Paso 2:</strong> Ingresa el código de 6 dígitos que aparece en la app para confirmar.
              </p>
              <div style={S.otpWrap}>
                {otp.map((digit, i) => (
                  <input key={i} id={`cfg-otp-${i}`} style={S.otpInput}
                    type="text" inputMode="numeric" maxLength={1} value={digit}
                    onChange={e => handleOtp(i, e.target.value)}
                    onKeyDown={e => handleOtpKey(i, e)}
                    autoFocus={i===0} />
                ))}
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <button style={S.btnGray} onClick={() => { setPaso2fa('idle'); setOtp(['','','','','','']); setError2fa(''); }}>Cancelar</button>
                <button style={S.btnSave} onClick={verificar2fa}>✓ Verificar y activar</button>
              </div>
            </>
          )}

          {status2fa && paso2fa === 'idle' && (
            <p style={{ fontSize:13, color:'#7A8F89', lineHeight:1.6 }}>
              ✅ Tu cuenta está protegida con Google Authenticator. Cada inicio de sesión requiere verificación adicional.
            </p>
          )}
        </div>
      </div>

      {/* Notificaciones */}
      <div style={S.card}>
        <div style={S.cardHdr}><div style={S.cardTitle}>🔔 Notificaciones</div></div>
        <div style={S.cardBody}>
          {[
            { key:'pagoVencido',   label:'Alerta de pago vencido',       sub:'Notificar cuando un negocio no haya pagado' },
            { key:'proximoVencer', label:'Aviso de próximo vencimiento',  sub:'Notificar 3 días antes de que venza una suscripción' },
            { key:'nuevaRegistro', label:'Nuevo negocio registrado',      sub:'Notificar cuando se registre un nuevo cliente' },
            { key:'waPagoVencido', label:'Envío automático por WhatsApp', sub:'Enviar mensaje de cobro automático al vencer' },
          ].map(item => (
            <div key={item.key} style={{ ...S.toggleRow, ...(item.key==='waPagoVencido'?{borderBottom:'none'}:{}) }}>
              <div>
                <div style={S.toggleLbl}>{item.label}</div>
                <div style={S.toggleSub}>{item.sub}</div>
              </div>
              <button style={{ ...S.toggle, background:notif[item.key]?'#075E54':'#E4EDE8' }} onClick={() => toggleNotif(item.key)}>
                <div style={{ position:'absolute', top:3, left:notif[item.key]?21:3, width:16, height:16, borderRadius:'50%', background:'white', transition:'left .2s' }} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}